"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.offlineDataServiceFactory = exports.OfflineDataServiceImpl = exports.SNAPSHOT_KEY_LISTS = exports.SNAPSHOT_KEY_SCHEDULE = exports.SNAPSHOT_KEY_RECENT_LAST = exports.SNAPSHOT_KEY_RECENT = void 0;
var authInterceptor_1 = require("./authInterceptor");
var localDataStore_1 = require("./localDataStore");
var syncConflictUtils_1 = require("./syncConflictUtils");
exports.SNAPSHOT_KEY_RECENT = 'recent';
/** Alias written on every successful Recent cache — cold boot without personId. */
exports.SNAPSHOT_KEY_RECENT_LAST = 'recent:__last__';
exports.SNAPSHOT_KEY_SCHEDULE = 'schedule';
exports.SNAPSHOT_KEY_LISTS = 'lists';
function isRecentSnapshot(value) {
    if (!value || typeof value !== 'object') {
        return false;
    }
    var v = value;
    return Array.isArray(v.recent) && v.personId != null && typeof v.cachedAt === 'string';
}
function personSegment(personId) {
    return personId !== undefined && personId !== null ? String(personId) : 'anon';
}
function makeSyncId() {
    return "sync-".concat(Date.now(), "-").concat(Math.random().toString(36).slice(2, 10));
}
var OfflineDataServiceImpl = /** @class */ (function () {
    function OfflineDataServiceImpl($q, store, getNavigatorOnline) {
        if (getNavigatorOnline === void 0) { getNavigatorOnline = function () { return navigator.onLine; }; }
        this.$q = $q;
        this.store = store;
        this.getNavigatorOnline = getNavigatorOnline;
    }
    OfflineDataServiceImpl.prototype.isOnline = function () {
        return this.getNavigatorOnline();
    };
    OfflineDataServiceImpl.prototype.snapshotKey = function (kind, personId) {
        return "".concat(kind, ":").concat(personSegment(personId));
    };
    OfflineDataServiceImpl.prototype.cacheRecentSnapshot = function (snapshot) {
        var _this = this;
        var deferred = this.$q.defer();
        var personKey = this.snapshotKey(exports.SNAPSHOT_KEY_RECENT, snapshot.personId);
        this.store
            .put(localDataStore_1.STORE_SNAPSHOTS, personKey, snapshot)
            .then(function () { return _this.store.put(localDataStore_1.STORE_SNAPSHOTS, exports.SNAPSHOT_KEY_RECENT_LAST, snapshot); })
            .then(function () { return deferred.resolve(); })
            .catch(function (error) { return deferred.reject(error); });
        return deferred.promise;
    };
    OfflineDataServiceImpl.prototype.loadRecentSnapshot = function (personId) {
        var deferred = this.$q.defer();
        this.store
            .get(localDataStore_1.STORE_SNAPSHOTS, this.snapshotKey(exports.SNAPSHOT_KEY_RECENT, personId))
            .then(function (value) { return deferred.resolve(value); })
            .catch(function (error) { return deferred.reject(error); });
        return deferred.promise;
    };
    OfflineDataServiceImpl.prototype.loadLastRecentSnapshot = function () {
        var _this = this;
        var deferred = this.$q.defer();
        this.store
            .get(localDataStore_1.STORE_SNAPSHOTS, exports.SNAPSHOT_KEY_RECENT_LAST)
            .then(function (last) {
            if (isRecentSnapshot(last)) {
                deferred.resolve(last);
                return;
            }
            // Legacy caches without __last__ alias: pick newest recent:* by cachedAt
            return _this.store.getAll(localDataStore_1.STORE_SNAPSHOTS).then(function (all) {
                var best = null;
                for (var _i = 0, all_1 = all; _i < all_1.length; _i++) {
                    var value = all_1[_i];
                    if (!isRecentSnapshot(value)) {
                        continue;
                    }
                    if (!best || String(value.cachedAt) > String(best.cachedAt)) {
                        best = value;
                    }
                }
                deferred.resolve(best);
            });
        })
            .catch(function (error) { return deferred.reject(error); });
        return deferred.promise;
    };
    OfflineDataServiceImpl.prototype.cacheScheduleSnapshot = function (snapshot) {
        var deferred = this.$q.defer();
        this.store
            .put(localDataStore_1.STORE_SNAPSHOTS, this.snapshotKey(exports.SNAPSHOT_KEY_SCHEDULE, snapshot.personId), snapshot)
            .then(function () { return deferred.resolve(); })
            .catch(function (error) { return deferred.reject(error); });
        return deferred.promise;
    };
    OfflineDataServiceImpl.prototype.loadScheduleSnapshot = function (personId) {
        var deferred = this.$q.defer();
        this.store
            .get(localDataStore_1.STORE_SNAPSHOTS, this.snapshotKey(exports.SNAPSHOT_KEY_SCHEDULE, personId))
            .then(function (value) { return deferred.resolve(value); })
            .catch(function (error) { return deferred.reject(error); });
        return deferred.promise;
    };
    OfflineDataServiceImpl.prototype.enqueueSync = function (entry) {
        var id = (entry.id && String(entry.id).trim()) || makeSyncId();
        var record = __assign(__assign({}, entry), { id: id, createdAt: new Date().toISOString(), status: 'pending', attempts: 0, lastError: null });
        var deferred = this.$q.defer();
        this.store
            .put(localDataStore_1.STORE_SYNC_QUEUE, id, record)
            .then(function () { return deferred.resolve(id); })
            .catch(function (error) { return deferred.reject(error); });
        return deferred.promise;
    };
    OfflineDataServiceImpl.prototype.listPendingSync = function () {
        return this.listSyncByStatus('pending');
    };
    OfflineDataServiceImpl.prototype.listFailedSync = function () {
        return this.listSyncByStatus('failed');
    };
    OfflineDataServiceImpl.prototype.getSyncEntry = function (id) {
        var deferred = this.$q.defer();
        this.store
            .get(localDataStore_1.STORE_SYNC_QUEUE, id)
            .then(function (value) { return deferred.resolve(value); })
            .catch(function (error) { return deferred.reject(error); });
        return deferred.promise;
    };
    OfflineDataServiceImpl.prototype.deleteSyncEntry = function (id) {
        var deferred = this.$q.defer();
        this.store
            .delete(localDataStore_1.STORE_SYNC_QUEUE, id)
            .then(function () { return deferred.resolve(); })
            .catch(function (error) { return deferred.reject(error); });
        return deferred.promise;
    };
    OfflineDataServiceImpl.prototype.retrySyncEntry = function (id, options) {
        var _this = this;
        return this.getSyncEntry(id).then(function (entry) {
            var _a;
            if (!entry) {
                return null;
            }
            var retried = __assign(__assign({}, entry), { status: 'pending', lastError: null, serverRow: null, conflictAt: null, baseRowUpdatedAt: (options === null || options === void 0 ? void 0 : options.clearBaseRowUpdatedAt) ? null : (_a = entry.baseRowUpdatedAt) !== null && _a !== void 0 ? _a : null });
            return _this.putSyncEntry(retried).then(function () { return retried; });
        });
    };
    OfflineDataServiceImpl.prototype.listSyncByStatus = function (status) {
        var deferred = this.$q.defer();
        this.store
            .getAll(localDataStore_1.STORE_SYNC_QUEUE)
            .then(function (entries) { return deferred.resolve(entries.filter(function (e) { return e.status === status; })); })
            .catch(function (error) { return deferred.reject(error); });
        return deferred.promise;
    };
    OfflineDataServiceImpl.prototype.putSyncEntry = function (entry) {
        var deferred = this.$q.defer();
        this.store
            .put(localDataStore_1.STORE_SYNC_QUEUE, entry.id, entry)
            .then(function () { return deferred.resolve(); })
            .catch(function (error) { return deferred.reject(error); });
        return deferred.promise;
    };
    OfflineDataServiceImpl.prototype.flushSyncQueue = function (executor) {
        var _this = this;
        return this.listPendingSync().then(function (entries) {
            // Always attempt flush — do not gate on navigator.onLine (partial outages still "online")
            if (!entries.length) {
                return { processed: 0, failed: 0, remaining: 0 };
            }
            var processed = 0;
            var failed = 0;
            var chain = entries.reduce(function (promise, entry) {
                return promise.then(function () {
                    return executor(entry)
                        .then(function () {
                        processed++;
                        return _this.store.delete(localDataStore_1.STORE_SYNC_QUEUE, entry.id);
                    })
                        .catch(function (error) {
                        var _a, _b, _c;
                        failed++;
                        var meta = (0, syncConflictUtils_1.getSyncFailureMeta)(error);
                        var updated = __assign(__assign({}, entry), { status: 'failed', attempts: entry.attempts + 1, lastError: meta.message, serverRow: (_b = (_a = meta.serverRow) !== null && _a !== void 0 ? _a : entry.serverRow) !== null && _b !== void 0 ? _b : null, conflictAt: meta.isConflict ? new Date().toISOString() : (_c = entry.conflictAt) !== null && _c !== void 0 ? _c : null });
                        return _this.putSyncEntry(updated);
                    });
                });
            }, _this.$q.resolve());
            return chain.then(function () {
                return _this.listPendingSync().then(function (remainingEntries) { return ({
                    processed: processed,
                    failed: failed,
                    remaining: remainingEntries.length,
                }); });
            });
        });
    };
    OfflineDataServiceImpl.prototype.bindConnectivity = function ($window, $rootScope) {
        var _this = this;
        // Browser online event is only a *retry hint* (often fires after real recovery).
        // Never treat offline event or navigator.onLine as source of truth for degraded mode.
        var emit = function (reason) {
            $rootScope.$broadcast('offline:connectivity', {
                reason: reason,
                // kept for back-compat; callers must not gate data paths on this
                online: reason === 'online' ? true : reason === 'offline' ? false : _this.isOnline(),
            });
        };
        $window.addEventListener('online', function () { return emit('online'); });
        $window.addEventListener('offline', function () { return emit('offline'); });
        emit('init');
    };
    /**
     * Whether a failed/non-OK response should keep showing IndexedDB snapshots / queue writes.
     * Decided only from HTTP/transport/infra outcomes — never navigator.onLine.
     * Covers timeouts, DNS black-holes (status 0), gateways, and DB_CONNECTION_FAILED bodies.
     */
    OfflineDataServiceImpl.prototype.shouldUseLocalFallback = function (error) {
        if (!error || typeof error !== 'object') {
            return false;
        }
        var err = error;
        var status = err.status;
        // 0 / -1 / null: network reset, DNS fail, abort, Angular timeout
        if (status === 0 || status === -1 || status == null) {
            return true;
        }
        // Slow/unreachable edge: client timeout, bad gateway, unavailable, gateway timeout
        if (status === 408 || status === 502 || status === 503 || status === 504) {
            return true;
        }
        // HTTP 200 (or other) with { Result: ERROR, Error: DB_CONNECTION_FAILED }
        if ((0, authInterceptor_1.isInfrastructureRefreshFailure)(err.data)) {
            return true;
        }
        return false;
    };
    return OfflineDataServiceImpl;
}());
exports.OfflineDataServiceImpl = OfflineDataServiceImpl;
exports.offlineDataServiceFactory = [
    '$q',
    function ($q) {
        return new OfflineDataServiceImpl($q, new localDataStore_1.IndexedDbLocalDataStore());
    },
];
